import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Jumbotron, Button, Carousel } from 'react-bootstrap';


function roomIdGenerator() {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 6; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
    return "/room/"+text;
}

export class Welcome extends Component {
  render(){
    return(
        <Jumbotron align="middle" className="bsStyle">
          <h1> &lt;techInterview/&gt;</h1><br/>
          <p>Assessing candidates has never been this simple.</p><br/><br/>
          <p>just click start session, share the url with the candidate</p><br/><br/>
          <p>and you can watch them write code</p><br/><br/>
          <Link to={roomIdGenerator()}><Button bsStyle="default" bsSize="large">start session...</Button></Link>
        </Jumbotron>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Welcome.js